/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BabylonValidatorListRequest = {
    status?: BabylonValidatorListRequest.status;
    sortField?: BabylonValidatorListRequest.sortField;
    sortDirection?: BabylonValidatorListRequest.sortDirection;
    term?: string;
    page?: number;
    size?: number;
};

export namespace BabylonValidatorListRequest {

    export enum status {
        BONDED = 'BONDED',
        INACTIVE = 'INACTIVE',
        JAILED = 'JAILED',
    }

    export enum sortField {
        VOTING_POWER = 'VOTING_POWER',
        PARTICIPATION = 'PARTICIPATION',
        UPTIME = 'UPTIME',
        COMMISSION = 'COMMISSION',
    }

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

